import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MonthlySalesChart = () => {
    const purchases = [
        { month: "2024-01", totalSales: "1600000.00", totalOrders: "2" },
        { month: "2023-06", totalSales: "1045000.00", totalOrders: "2" },
        { month: "2023-09", totalSales: "150000.00", totalOrders: "1" },
        { month: "2024-02", totalSales: "920000.00", totalOrders: "3" },
        { month: "2023-08", totalSales: "120000.00", totalOrders: "1" },
        { month: "2024-04", totalSales: "240000.00", totalOrders: "1" },
        { month: "2024-05", totalSales: "480000.00", totalOrders: "2" },
        { month: "2024-06", totalSales: "120000.00", totalOrders: "1" },
        { month: "2023-11", totalSales: "240000.00", totalOrders: "2" },
        { month: "2024-10", totalSales: "5130000.00", totalOrders: "9" },
        { month: "2024-11", totalSales: "420000.00", totalOrders: "3" },
    ];

    // Sort data by month
    purchases.sort((a, b) => new Date(a.month) - new Date(b.month));

    const data = {
        labels: purchases.map(item => item.month),
        datasets: [
            {
                label: 'Total Sales ($)',
                data: purchases.map(item => parseFloat(item.totalSales)),
                borderColor: '#F8A81B',
                backgroundColor: 'rgba(248, 168, 27, 0.3)',
                borderWidth: 2,
                tension: 0.3,
                yAxisID: 'y1',
            },
            {
                label: 'Total Orders',
                data: purchases.map(item => parseInt(item.totalOrders)),
                borderColor: '#00AB9A',
                backgroundColor: 'rgba(0, 171, 154, 0.3)',
                borderWidth: 2,
                tension: 0.3,
                yAxisID: 'y2',
            }
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: '#333',
                    boxWidth: 12,
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.dataset.label || '';
                        return `${label}: ${context.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: '#000',
                },
                grid: {
                    display: false,
                },
            },
            y1: {
                type: 'linear',
                position: 'left',
                title: {
                    display: true,
                    text: 'Total Sales ($)',
                },
                ticks: {
                    callback: (value) => `${value / 1000}k`,
                },
                beginAtZero: true,
            },
            y2: {
                type: 'linear',
                position: 'right',
                title: {
                    display: true,
                    text: 'Total Orders',
                },
                beginAtZero: true,
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };

    return (
        <div className="w-full bg-white rounded-lg p-4 shadow-md">
            <p className="mb-4 text-xl font-semibold text-gray-800">Monthly Sales and Orders</p>
            <Line data={data} options={options} />
        </div>
    );
};

export default MonthlySalesChart;
